import React from 'react';

import CssBaseline from '@material-ui/core/CssBaseline';
import Link from '@material-ui/core/Link';
import Paper from '@material-ui/core/Paper';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import { Divider } from '@material-ui/core';

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {' © '}
      <Link color="inherit" href="https://github.com/DataMascara/mimo_cat">
        data mascara
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

// function GH(props) {
//   return (
//     <Link color="primary" href="https://github.com/${props.username">
//         {props.username}
//     </Link> 
//   );
// }

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100vh'
  },
  image: {
    backgroundImage: 'url("unnamed.jpg")',
    backgroundRepeat: 'no-repeat',
    backgroundColor:
      theme.palette.type === 'light' ? theme.palette.grey[50] : theme.palette.grey[900],
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  },
  paper: { 
    margin: theme.spacing('auto'),
    padding: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    maxWidth: 600,
    background: '#000200'
  },
  bottom: {
    position: 'fixed',
    bottom: 0,
    alignContent: "flex-end"
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

export default function SignInSide() {
  const classes = useStyles();

  return (
    <Grid container component="main" className={classes.root}>
      <CssBaseline />
      <Grid item xs={false} sm={4} md={7} className={classes.image} />
      <Grid item xs={12} sm={8} md={5} component={Paper}  elevation={6} square>
        <div className={classes.paper}>
        <Grid container > 
          <Box  style={{ textAlign : 'center',  width: '600', mx: 'auto' }}  >
            
          <br />
          
          <Typography component="h1" variant="body2">
            <b>About</b>
          </Typography>
          </Box>
          <br />


          <Typography variant="body2" component="p" gutterBottom>
            <br />
            This is an online movement lexicon created by interdisciplinary artist Maho Ogawa in collaboration with computer programmer Katherine Chuang. 
            <br />
            <br />
          </Typography>
          <Typography variant="body2" component="p" gutterBottom>
          This movement lexicon consists of 89 movement video clips in eight categories, started as research about Ogawa's Japanese-ness through body language, by archiving movements from the West and East, examining the kinetic and symbolic meaning of each movement language. 

            <br />
            <br />
          </Typography>
          <Typography variant="body2" component="p" gutterBottom>
          This movement lexicon is used as a movement notation in the creative process of Ogawa's video/ live performances, teaching method for movement classes, and shared with the audience/viewers as process art.
            <br />
            <br />
          </Typography>

          <Typography component="p" variant="body2" gutterBottom>
            Maho Ogawa <br />
            <Link href="https://www.suisoco.com" variant="body2">www.suisoco.com</Link> 
            
            <br />
            <br />
          </Typography>
          </Grid>
          <Divider />
  
          <Box  style={{  width: '100%', }} >
            <Link href="/" variant="body2" className={classes.legal}>
              {"← Home"}
            </Link>
          </Box>
          <Box className={classes.bottom}>
            <Copyright />
          </Box>
        </div>
      </Grid>
    </Grid>
  );
}